/** Stable element id shared by the list (hash) and the detail cards. */
export const newsAnchorId = (
  news: { news_id?: string | number; id?: string | number } | null | undefined,
  index = 0
): string => {
  const raw = news?.news_id ?? news?.id ?? index;
  const safe = String(raw).replace(/[^A-Za-z0-9_-]/g, '');
  return `news-${safe || index}`;
};
